import { arrayOfInternalRates, internalRate } from "~/schemas/schema.internal_rates.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchAllInternalRates = () => {
  return {
    types: [
      actionTypes.FETCH_ALL_INTERNAL_RATES_LOADING,
      actionTypes.FETCH_ALL_INTERNAL_RATES_SUCCESS,
      actionTypes.FETCH_ALL_INTERNAL_RATES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/internal-rates`,
      }),
    payload: {
      schema: arrayOfInternalRates,
    },
  };
};

export const deleteUserInternalRate = (id) => {
  return {
    types: [
      actionTypes.DELETE_USER_INTERNAL_RATE_LOADING,
      actionTypes.DELETE_USER_INTERNAL_RATE_SUCCESS,
      actionTypes.DELETE_USER_INTERNAL_RATE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/internal-rates/${id}`,
        method: `DELETE`,
      }),
    payload: {
      id,
    },
  };
};

export const addUserInternalRate = (userId, attributes) => {
  return {
    types: [
      actionTypes.ADD_USER_INTERNAL_RATE_LOADING,
      actionTypes.ADD_USER_INTERNAL_RATE_SUCCESS,
      actionTypes.ADD_USER_INTERNAL_RATE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/internal-rate`,
        method: `POST`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: internalRate,
      },
    },
  };
};

export const updateUserInternalRate = (userId, attributes) => {
  return {
    types: [
      actionTypes.UPDATE_USER_INTERNAL_RATE_LOADING,
      actionTypes.UPDATE_USER_INTERNAL_RATE_SUCCESS,
      actionTypes.UPDATE_USER_INTERNAL_RATE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/internal-rate`,
        method: `PUT`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: internalRate,
      },
    },
  };
};
